import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { delay } from "../../../features/dataFunctions/dataFunctions"
import { setPathNormativitiesSearchValue } from "../../../stateManagement/reducers"

const clearButtonIconSrc = require('../../../assets/images/fontAwesomeIcons/xmark-solid.svg').default

export default function PathNormativitiesListSearchBar() {

    const dispatch = useDispatch()
    const [inputSearchValue, setInputSearchValue] = useState<any>('')

    // Изменение значение для поиска

    useEffect(() => {
        const trimmedInputValue = inputSearchValue.trim()
        delay(() => dispatch(setPathNormativitiesSearchValue((trimmedInputValue))), 300)
    }, [inputSearchValue])

    // Очистка поисковой строки

    useEffect(() => {
        return () => {
            setInputSearchValue('')
            delay(() => dispatch(setPathNormativitiesSearchValue((null))), 300)
        }
    }, [])

    function clearSearchValue() {
        setInputSearchValue('')
        dispatch(setPathNormativitiesSearchValue(('')))
    }

    return (
        <div className="path-normativities-list-searchbar-div">
            <div className="path-normativities-list-searchbar-inputs-div">
                <input
                    id="path-normativities-list-searchbar-input"
                    value={inputSearchValue}
                    onChange={(e: any) => setInputSearchValue(e.target.value)}
                    placeholder="Найти участки нормативности по названию дороги или направления"
                    autoComplete="off"
                />
                <button className="path-normativities-list-searchbar-clear-button" onClick={clearSearchValue}>
                    <img src={clearButtonIconSrc} />
                </button>
            </div>
        </div>
    )
}
